// Common
import { Component, inject } from '@angular/core';

// Services
import { GoogleAnalyticsService } from '@frontendlib/common/services/google-analytics.service';
import { BoardService } from '@modules/tasks/services/board.service';

// Types
import { Section } from '@modules/common/types/section';

@Component({
  selector: 'app-section-context-menu',
  templateUrl: './row-context-menu.component.html',
  styleUrls: ['./row-context-menu.component.less'],
  standalone: false,
})
export class SectionContextMenuComponent {
  public section: Section;
  public canMoveUp = true;
  public canMoveDown = true;

  private readonly ga = inject(GoogleAnalyticsService);
  private readonly boardService = inject(BoardService);

  /**
   * Actions
   */

  delete(): void {
    this.ga.trackEvent('section-context-menu', 'delete-permanently');
    this.boardService.removeSection(this.section);
  }

  addTop(): void {
    this.ga.trackEvent('section-context-menu', 'insert-top');
    this.boardService.addSection(false, this.section.position);
  }

  addBottom(): void {
    this.ga.trackEvent('section-context-menu', 'insert-bottom');
    this.boardService.addSection(true, this.section.position);
  }

  moveUp(): void {
    this.ga.trackEvent('section-context-menu', 'move-up');
    this.boardService.moveSection(this.section, -1);
  }

  moveDown(): void {
    this.ga.trackEvent('section-context-menu', 'move-down');
    this.boardService.moveSection(this.section, 1);
  }
}
